import React from 'react'
import 'antd/dist/antd.css'
import { ConfigProvider } from 'antd'
import { AppShell } from './components'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './services/auth'
import { SecurityProvider } from './services/security'
import ruRU from 'antd/lib/locale/ru_RU'
import 'moment/locale/ru'
import moment from 'moment-timezone'
import {
  companiesListPath,
  employeesListPath,
  invoicesPath,
  ordersPath,
  transactionsPath,
} from './routes/paths'
import {
  BankOutlined,
  DollarCircleOutlined,
  QrcodeOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { FailedOrders } from './components'

moment.tz.setDefault('UTC')

export const App: React.FunctionComponent = () => {
  const items = [
    { path: companiesListPath(), title: 'Компании', icon: <BankOutlined /> },
    { path: employeesListPath(), title: 'Сотрудники', icon: <UserOutlined /> },
    {
      path: ordersPath(),
      title: (
        <FailedOrders>
          <div style={{ display: 'inline-block', paddingRight: 20 }}>
            Заказы
          </div>
        </FailedOrders>
      ),
      icon: <UnorderedListOutlined />,
    },
    {
      path: transactionsPath(),
      title: 'Финансовые операции',
      icon: <DollarCircleOutlined />,
    },
    {
      path: invoicesPath(),
      title: 'Счета на оплату',
      icon: <QrcodeOutlined />,
    },
  ]

  return (
    <ConfigProvider locale={ruRU}>
      <AuthProvider>
        <SecurityProvider>
          <BrowserRouter>
            <AppShell items={items} />
          </BrowserRouter>
        </SecurityProvider>
      </AuthProvider>
    </ConfigProvider>
  )
}
